import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./index.css";

const ContactForm = () => {
  const [result, setResult] = React.useState("");
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "d207344c-6399-4cd7-b920-5d196427385b");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        // Navigate to the Thank You page on success
        navigate("/thank-you");
      } else {
        console.log("Error", data);
        setResult(data.message);
      }
    } catch (error) {
      console.error("Network Error", error);
      setResult("An error occurred while sending the form. Please try again.");
    }
  };

  return (
    <div className="contact-form-container">
      <form className="contact-form" onSubmit={onSubmit}>
        <label htmlFor="name">Name</label>
        <input
          type="text"
          name="name"
          id="name"
          placeholder="Enter Your Name"
          required
        />
        <label htmlFor="companyName">Company Name</label>
        <input
          type="text"
          name="companyName"
          id="companyName"
          placeholder="Enter Your Company Name"
          required
        />
        <label htmlFor="numberOfApartments">
          How many apartment properties are there?
        </label>
        <input
          type="number"
          name="numberOfApartments"
          id="numberOfApartments"
          placeholder="Number of Apartments"
          required
        />
        <label htmlFor="totalUnitsServiced">Total Units to be serviced</label>
        <input
          type="number"
          name="totalUnitsServiced"
          id="totalUnitsServiced"
          placeholder="Total Units"
          required
        />
        <label htmlFor="email">Email</label>
        <input
          type="email"
          name="email"
          id="email"
          placeholder="Enter Your Email"
          required
        />
        <label htmlFor="phone">Phone</label>
        <input
          type="tel"
          name="phone"
          id="phone"
          placeholder="Enter Your Phone Number"
          required
        />
        <label htmlFor="message">Message</label>
        <textarea
          name="message"
          id="message"
          placeholder="Enter Your Message You Want To Convey"
          rows="4"
          required
        ></textarea>
        <button type="submit" name="send message">
          Send Message
        </button>
      </form>
      <span className="result-sending">{result}</span>
    </div>
  );
};

export default ContactForm;
